(function() {

    'use strict';

    angular.module('Services').factory('ManifestViewShipmentFactory', ManifestViewShipmentFactory);

    function ManifestViewShipmentFactory($uibModal){

        return function (scope){

            var modalProperties = {
                animation: false,
                windowClass: 'fade',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/elements/manifest-view-shipment-modal.html',
                controller: function($uibModalInstance, $scope, Carrier, ManifestShipmentsTable){
                    $scope.serviceDetailsList = {};

                    $scope.action = function(cond){
                        $uibModalInstance.close(cond);
                    };

                    if(scope){
                        angular.extend($scope, scope);
                    }

                    Carrier.getCarriers(function (data) {
                        $scope.serviceDetailsList.carriers = data;
                    }, function (error) {
                        console.log(error);
                    }).getServices(function (data) {
                        $scope.serviceDetailsList.services = data;
                        $scope.shipmentsTableData = new ManifestShipmentsTable($scope.serviceDetailsList, $scope.item.id).tableData;
                    });
                },
                size: 'lg',
                backdrop: 'static'
            };
            
            function getInstance() {
                return $uibModal.open(modalProperties);
            };

            this.getInstance = getInstance;
        };
    };
})();


// WEBPACK FOOTER //
// ./js/services/UX/ManifestViewShipmentFactory.js